import { render, staticRenderFns } from "./ListCertifies.vue?vue&type=template&id=70711548&"
import script from "./ListCertifies.vue?vue&type=script&lang=js&"
export * from "./ListCertifies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports